<template>
  <div class="head-container">
    <div class="head-top-box">
      <div class="head-title">
        <i class="el-icon-s-unfold iconfont" v-if="isCollapse" @click="isCollapse = false"></i>
        <i class="el-icon-s-fold iconfont" v-else @click="isCollapse = true"></i>
        思远销售通知系统
      </div>
      <div class="right-box">
        <div class="user-box" v-if="$store.state.name">欢迎你，{{ $store.state.name }}</div>
        <div class="no-login" v-else>未登录</div>
        <i class="el-icon-switch-button setting-img" @click="exit"></i>
      </div>
    </div>
    <div class="index-content">
      <el-menu
        :collapse="isCollapse"
        default-active="2"
        class="el-menu-vertical-demo"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
        @select="handleSelect"
      >
        <el-menu-item index="2">
          <i class="el-icon-document-copy"></i>
          <span slot="title">销售出货单</span>
        </el-menu-item>
        <el-menu-item index="1">
          <i class="el-icon-document"></i>
          <span slot="title">仓库出货单</span>
        </el-menu-item>
        <el-menu-item index="4">
          <i class="el-icon-document-checked"></i>
          <span slot="title">代理商地址</span>
        </el-menu-item>
        <el-menu-item index="5">
          <i class="el-icon-document-checked"></i>
          <span slot="title">短信模板</span>
        </el-menu-item>
        <el-menu-item index="6">
          <i class="el-icon-document-checked"></i>
          <span slot="title">出货单</span>
        </el-menu-item>
      </el-menu>
      <slot></slot>
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible" :close-on-click-modal="false" width="30%">
      <span>是否退出登录</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  apiCollection,
  apiResource,
  apiFormSubmit,
  apiDelete,
  apiPut,
  apiCollectionbill,
  apiResourcebill
} from '../api/index';

export default {
  name: 'headerComBox',
  data() {
    return {
      dialogVisible: false,
      isCollapse: false,
      navList: [
        {
          name: '销售出货单',
          id: '2',
          url: '/'
        },
        {
          name: '仓库出货单',
          id: '1',
          url: '/warehouseList'
        },
        {
          name: '代理商地址',
          id: '4',
          url: '/agentAddress'
        },
        {
          name: '短信模板',
          id: '5',
          url: '/message'
        },
        {
          name: '出货单',
          id: '6',
          url: '/billList'
        }
      ]
    };
  },
  created() {},
  methods: {
    handleSelect(key, keyPath) {
      this.navList.forEach((item, idx) => {
        if (item.id === key) {
          this.$router.push(this.navList[idx].url);
        }
      });
    },
    // 退出登录
    exit() {
      this.dialogVisible = true;
    },
    confirm() {
      const arr = [
        apiCollection,
        apiResource,
        apiFormSubmit,
        apiDelete,
        apiPut,
        apiCollectionbill,
        apiResourcebill
      ];
      arr.forEach(item => {
        item.defaults.headers['x-token'] = '';
      });
      localStorage.removeItem('x-token');
      localStorage.removeItem('isLogin');
      localStorage.removeItem('userInfo');
      this.clearAllCookie();
      const url = window.location.href;
      window.location.href = 'https://login.tkplusemi.com?url=' + url;
      //   this.$router.replace({ path: '/login' });
    },
    //清除所有cookie函数
    clearAllCookie() {
      let date = new Date();
      date.setTime(date.getTime() - 10000);
      //keys为所要删除cookie的名字
      let keys = ['userinfo', 'fileCookie'];
      if (keys) {
        for (var i = keys.length; i--; )
          document.cookie = '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.head-container {
  height: 100%;
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
  .head-top-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    padding: 0 32px;
    background-color: #ffffff;
    box-shadow: 1px 2px 3px 0 #cacaca;
  }
  .head-title {
    font-size: 24px;
    font-weight: bold;
    .iconfont {
      cursor: pointer;
    }
  }
  .right-box {
    display: flex;
    position: relative;
    cursor: pointer;
    &:hover {
      .exit-box {
        display: block;
      }
    }
  }
  .user-box {
    font-size: 16px;
  }
  .setting-img {
    margin-left: 20px;
    font-size: 20px;
  }
  .index-content {
    display: flex;
    height: calc(100vh - 60px);
  }
  .el-menu-vertical-demo {
    text-align: left;
    span,
    .el-menu-item {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headerComBox.vue